/* ========================================================= * Material Kit 2 PRO React - v2.0.0 ========================================================= * Product Page: https://www.creative-tim.com/product/material-kit-pro-react * Copyright 2021 Creative Tim (https://www.creative-tim.com) Coded by www.creative-tim.com ========================================================= * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software. */


// react
import { useState } from "react";
import { useMaterialUIController } from "/context";

// next
import dynamic from "next/dynamic";
import Image from "next/image";

// PRO
import MDBox from "/components/MDBox";

// Images
import macbook from "/assets/img/macbook.png";

// Utils
import validateEmail from "/utils/validateEmail";

// MUI
const Container = dynamic(() => import("@mui/material/Container"), { loading: () => null });
const Grid = dynamic(() => import("@mui/material/Grid"), { loading: () => null });
const InputAdornment = dynamic(() => import("@mui/material/InputAdornment"), { loading: () => null });
const FormControl = dynamic(() => import("@mui/material/FormControl"), { loading: () => null });
const Tooltip = dynamic(() => import("@mui/material/Tooltip"), { loading: () => null });

// MUI Icons
const DoneRounded = dynamic(() => import("@mui/icons-material/DoneRounded"), { loading: () => null });
const ErrorRounded = dynamic(() => import("@mui/icons-material/ErrorRounded"), { loading: () => null });

// PRO
const MDButton = dynamic(() => import('/components/MDButton'), { loading: () => null });
const MDInput = dynamic(() => import('/components/MDInput'), { loading: () => null });
const MDTypography = dynamic(() => import('/components/MDTypography'), { loading: () => null });

function ALLDSubscribeToNewsletter({ snackbar, setSnackbar }) {
  const [controller] = useMaterialUIController();
  const [email, setEmail] = useState("");
  return (
    <>
      <Container>
        <Grid container alignItems="center">
          <Grid item sm={12} md={6} sx={{ ml: { xs: 0, lg: 3 }, mb: { xs: 12, md: 0 } }}>
            <MDTypography variant="h4">Be the first to see the news</MDTypography>
            <MDTypography variant="body2" color="text" mb={3}>
              Tips and ideas for your outdoor living space.
            </MDTypography>
            <Grid container spacing={1}>
              <Grid item xs={8}>
                <FormControl sx={{ width: "100%" }}>
                  <MDInput
                    type="email"
                    label="Email Here..."
                    fullWidth
                    variant="standard"
                    placeholder="Your email address"
                    //  InputLabelProps={{ shrink: true }}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    InputProps={{
                      endAdornment: (
                        email !== "" && !validateEmail(email) ? (
                          <Tooltip title="Not a valid email">
                            <span>
                              <InputAdornment position="end">
                                <ErrorRounded color="error" />
                              </InputAdornment>
                            </span>
                          </Tooltip>
                        ) : email !== "" && validateEmail(email) ? (
                          <Tooltip title="Valid email">
                            <span>
                              <InputAdornment position="end">
                                <DoneRounded color="success" />
                              </InputAdornment>
                            </span>
                          </Tooltip>
                        ) : null
                      ),
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <MDButton variant="gradient" color="info" sx={{ height: "100%" }}
                  disabled={
                    email === "" ||
                    !validateEmail(email)
                  }
                  onClick={async (e) => {
                    e.preventDefault();
                    const result = await fetch("/api/subscribe-user-to-mailchimp", {
                      method: "POST",
                      headers: { "Content-Type": "application/json" },
                      body: JSON.stringify({
                        email: email,
                      }),
                    })
                      .then((response) => response.json())
                      .then((response) => response.message)
                      .catch(() => "error");
                    if (result !== "success") {
                      setSnackbar({ title: "Error!", content: "Subscribe didn't go through. Try again. ", color: "info" })
                    } else {
                      setEmail("");
                      setSnackbar({ title: "Success!", content: "Subscribed successfully! Yay!", color: "success" })
                    }
                  }}
                >
                  Subscribe
                </MDButton>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={5} sx={{ ml: "auto" }}>
            <MDBox position="relative">
              <Image
                src={macbook}
                alt="macbook"
                width={controller.mobileView ? 404 : 530}
                style={{ height: "auto" }}
              />
            </MDBox>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default ALLDSubscribeToNewsletter;
